import React, { useEffect, useState } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';
import { Button } from '../../../../components/Button';
import { AdminH1 } from '../../../components/AdminH1';
import { Tab } from '../../../components/Tab';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { Popup, UpdatePopupDto } from '../../../../types/popup';
import { PcPageEdit } from './PcPageEdit';
import { MobilePageEdit } from './MobliePageEdit';
import { getPopup, patchPopup } from '../../../../api/popupAPI';

export const PageEditMainPage = () => {
  const { pathname } = useLocation();
  const { push } = useHistory();
  const history = useHistory();
  const [popUp, setPopUp] = useState<Popup>();

  const form = useForm<UpdatePopupDto>({
    defaultValues: {
      pcContents: popUp?.pcContents,
      mobileContents: popUp?.mobileContents,
    },
  });

  const getList = () => {
    getPopup()
      .then((res) => {
        form.setValue('pcContents', res.data.pcContents);
        form.setValue('mobileContents', res.data.mobileContents);
        setPopUp(res.data);
      })
      .catch((err) => console.error(err.response));
  };

  useEffect(() => getList(), [history.location]);

  const onSave = () => {
    if (popUp?.id) {
      patchPopup(popUp?.id, form.getValues())
        .then(() => {
          toast.success('저장되었습니다.');
        })
        .catch((e) => console.error(e.response));
    }
  };

  return (
    <>
      <div className="flex items-center justify-between">
        <AdminH1>팝업 페이지 관리</AdminH1>
        <Button
          text="Save"
          className="h-fit w-fit bg-gray-800 px-4 py-2 text-white"
          onClick={onSave}
        />
      </div>
      {/* <div className="flex space-x-4 border-b">
        <Tab
          text="PC"
          selected={pathname === '/admin/popup/page/pc'}
          onClick={() => push('/admin/popup/page/pc')}
        />
        <Tab
          text="MOBILE"
          selected={pathname === '/admin/popup/page/mobile'}
          onClick={() => push('/admin/popup/page/mobile')}
        />
      </div> */}
      <Switch>
        {/* <Route
          path="/admin/popup/page/pc"
          render={() => <PcPageEdit form={form} />}
        /> */}
        <Route
          path="/admin/popup/page/mobile"
          render={() => <MobilePageEdit form={form} />}
        />
        <Route path="/admin/popup/page">
          <Redirect to="/admin/popup/page/mobile" />
        </Route>
      </Switch>
    </>
  );
};
